// lib/queries/getUserSessions.js

import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getUserSessions = ({ userId }) => {
  return axios.get(`/session/user/${userId}`);
};

export const useUserSessions = ({ userId, config }) => {
  return useQuery({
    ...config,
    queryKey: ['userSessions', userId],
    queryFn: () => getUserSessions({ userId }),
  });
};
